// Added by Sejune Oh on 2019-06-21
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Property } from 'csstype'
import { LOGIN_FORM_WIDTH, DEFAULT_SPACING, RED_COLOR } from '../Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = () => ({
    LoginPaperCopyRight: {
        position: 'absolute' as Property.Position,
        bottom: '-35px',
        left: '0',
        right: '0',
        fontSize: '12px',
        color: '#cdcdcd',
        textShadow: '1px 1px 1px #000', 
    },
    AutoFocusableInput: {
        padding: '9px 7px',
        margin: '9px 7px',
        borderRadius: '4px',
    },
    LoginSnackbarContent: {
        maxWidth: `${LOGIN_FORM_WIDTH}px`,
        backgroundColor: RED_COLOR,
        color: '#fff',
    },
    LoginFormInput: {
        marginBottom: `${DEFAULT_SPACING * 2}px`,
    },
    DescTxtWrapper: {
        display: 'flex' as Property.Display,
        color: '#999',
        width: '100%',
        justifyContent: 'space-between' as Property.JustifyContent,
        borderBottom: '2px solid #999',
        paddingBottom: `${DEFAULT_SPACING / 2}px`,
        paddingTop: `${DEFAULT_SPACING}px`,
        alignItems: 'baseline',
    },
    CPLogo: {
        fontWeight: 'bold' as Property.FontWeight,
        background: 'linear-gradient(to right, #187db1, #18b1b1)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    LoginFormCtrLabel: {
        margin: '0',
        marginTop: 6,
        padding: '0',
        '&>span': {
            padding: '0',
            marginRight: 6,
            lineHeight: 1,
        },
        '&>span:last-child': {
            marginRight: '0',
            color: '#ccc',
        },
    },
})

export default styles
